module.exports = __webpack_public_path__ + "static/media/atmCard.454ae05b.png";